import React from 'react'
import PropTypes from 'prop-types'
import CodeMirror from 'react-codemirror'
import 'codemirror/mode/javascript/javascript'
import 'codemirror/addon/display/placeholder'
import 'codemirror/addon/display/autorefresh'
import 'codemirror/lib/codemirror.css'

const CallToActions = ({ input, meta }) => {
  let callToActions
  try {
    callToActions = JSON.parse(input.value).length
  } catch (e) {}

  const maxEntries = 3

  return (
    <div>
      <ul className='br-dm-attachments__requirements'>
        <li>Maximum {maxEntries} call to action buttons can be added</li>
        <li>Use JSON syntax</li>
        <li>
          <code>type</code>,<code>label</code> and <code>url</code> are required
          for all buttons.
        </li>
        <li>
          <code>type</code> must always be set to <code>"web_url"</code>
        </li>
      </ul>

      <CodeMirror
        className={meta.error && 'error'}
        options={{
          lineNumbers: true,
          placeholder:
            '[\n {\n  "type":"web_url",\n  "label":"",\n  "url":""\n } \n]',
          autoRefresh: true,
          lineWrapping: true
        }}
        value={input.value}
        mode='javascript'
        onChange={input.onChange}
      />
      <div
        className={
          'br-input-footer' + (callToActions > maxEntries ? ' error' : '')
        }
      >
        <a
          href='https://developer.twitter.com/en/docs/direct-messages/buttons/api-reference/buttons'
          target='_blank'
          rel='noopener noreferrer'
        >
          <span
            className='fa fa-question-circle'
            title='Twitter API reference '
          />
        </a>
        <div className='br-entries-number'>
          {typeof callToActions === 'number' ? callToActions : 'N/A'}
          <span> / {maxEntries}</span>
        </div>
      </div>

      {/* Invalid JSON error */}

      {meta.error &&
        meta.error.json && (
          <div className='br-error'>
            <strong>Invalid JSON</strong>
          </div>
        )}

      {/* The error-list-header and error-list only show if any of the errors (entryErrors) have been set */}

      {meta.error &&
        meta.error.length && (
          <div>
            <div className='br-error-list-heading'>Error(s):</div>

            <ul className='br-error-list'>
              {meta.error.map((error, index) => (
                <li key={index} className='br-error'>
                  {error}
                </li>
              ))}
            </ul>
          </div>
        )}
    </div>
  )
}
CallToActions.propTypes = {
  input: PropTypes.any,
  meta: PropTypes.any
}

export default CallToActions



// WEBPACK FOOTER //
// ./src/pages/widgets/form/tweet-input/dm-attachments/call-to-actions.js